module.exports = __webpack_public_path__ + "static/media/9DESA4.4dda71a9.jpg";